import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.number.constructor";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.promise";
import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-unused-vars */
import { firstBy } from 'thenby';
import Vue from 'vue';
import { deepClone, prepareStats } from '@/modules/mm-utils';
import dayjs from 'dayjs';
import { API_REQUEST } from '@/api/';
import { serializeAsQueryString } from '@/api/serialize';
import rollbackWorkerDays from "./actions/common/rollbackWorkerDays";
import updateWorkerStats from "./actions/updateWorkerStats";
import applyTableView from "./actions/applyTableView";
import saveCellFast from "./actions/saveCellFast";
import load from "./actions/load";
import saveCellFull from "./actions/saveCellFull";
import duplicate from "./actions/duplicate";
import { updateVacancies, setVacancies, vacancies } from "./parts/vacancies";
import { updateDailyStats, setDailyStats, getDailyStats, getDailyStatsSummary, isPercent } from "./parts/dailyStats";
import { updateEfficiency, setEfficiency } from "./parts/efficiency";
import workerDaysByArg from "./actions/common/workerDaysByArg";
import workerStatsByArg from "./actions/common/workerStatsByArg";
import { getIndexedCollection, lens, splitArray } from '@/common/helpers';
import { getUniversalMutations, getUniversalGetters } from '@/common/store';
import { DEFAULT_WORK_DAY_TYPE_CODE, EMPLOYEE_EMPLOYMENT_STATUSES, INTERNAL_EMPLOYMENT_STATUSES, OUTSOURCE_EMPLOYMENT_STATUSES } from '@/config/time-table';
import { getCorrectShiftWorkEndTime, formFetchEmployeeParams, formWorker, fetchEmployeesChunked } from '@/modules/time-table'; // import { dayTypes as dayTypesMocked } from '../../../test/jest/__tests__/mocks/day-type'

var POLL_INTERVAL = 10;
var POLL_TIMEOUT = 15000;
var fetchEmployeeMemo = {};

var state = function state() {
  return {
    isLoading: false,
    updatedData: {},
    workerDays: [],
    workers: [],
    workerStats: {},
    dailyStats: {},
    // otherDailyStats: {}, // not 'PLAN_APPR', 'PLAN_UNAPPR', etc
    dayFilters: {},
    workTypes: [],
    loadingDay: '',
    tableCellParts: [],
    dailyStatsParam1: null,
    dailyStatsParam2: null,
    employeeStats: {},
    timesheetStats: {},
    mainTableCollapsed: true,
    vacancies: false,
    efficiency: {},
    refreshCoverageData: 0,
    sortType: '',
    tableCellKey: 0,
    tabels: [],
    cachedData: {
      workerDays: {},
      workerStats: {},
      efficiency: {}
    },
    employments: [],
    tasks: {},
    attendanceRecords: {},
    bottomCorners: {},
    dayInEditing: {},
    dayTypes: [],
    dayTypesById: {
      D: {
        name: 'Нет данных',
        short_name: 'НД'
      }
    },
    dayTypeStats: [],
    dayTypeOptions: [],
    workDayTypes: [],
    timesheetItems: [],
    workTypeNames: [],
    positions: [],
    workDays: {},
    workersForFullDayEditor: [],
    isFetchingWorkersForFullDayEditor: [],
    newShifts: {},
    removedShifts: {},
    updatedShifts: {}
  };
};

var timesheetItemsFetchCache = new Map();
var TIMESHEET_ITEM_REFETCH_INTERVAL = 1000 * 60;
var ALLOWED_WORKER_HOUR_METHODS = ['manual', 'manual_or_average_sawh_hours'];
var ALLOWED_WORKER_HOUR_EMPTY_METHODS = ['manual_or_average_sawh_hours'];
var WORKER_CHUNK_SIZE = 50;
var lastDayFilterDate;

function sortStatsData(_ref) {
  var workers = _ref.workers,
      stats = _ref.stats,
      sortField = _ref.sortField,
      sortDirection = _ref.sortDirection;
  var workersIndexed = getIndexedCollection(workers, 'employee_id');
  var sorted = workers.map(function (_ref2) {
    var employee_id = _ref2.employee_id;
    return _objectSpread(_objectSpread({}, stats[employee_id] || {}), {}, {
      id: employee_id
    });
  }).sort(firstBy(sortField, {
    direction: sortDirection
  })).map(function (_ref3) {
    var id = _ref3.id;
    return workersIndexed[id];
  });
  return sorted;
}

function addToShifts(state, cellId, shiftId, stateType) {
  var _state$stateType, _state$stateType$cell;

  if (!shiftId) return;

  if ((_state$stateType = state[stateType]) !== null && _state$stateType !== void 0 && (_state$stateType$cell = _state$stateType[cellId]) !== null && _state$stateType$cell !== void 0 && _state$stateType$cell.length) {
    if (!state[stateType][cellId].includes(shiftId)) {
      state[stateType][cellId].push(shiftId);
    }
  } else {
    state[stateType][cellId] = [shiftId];
  }
}

var mutations = _objectSpread(_objectSpread({}, getUniversalMutations(state())), {}, {
  setVacancies: setVacancies,
  setDailyStats: setDailyStats,
  setEfficiency: setEfficiency,
  increaseCoverageDataRefresh: function increaseCoverageDataRefresh(state) {
    state.cachedData.efficiency = {};
    state.refreshCoverageData += 1;
  },
  setMainTableCollapsed: function setMainTableCollapsed(state, value) {
    state.mainTableCollapsed = value;
  },
  setDailyStatsParam1: function setDailyStatsParam1(state, value) {
    state.dailyStatsParam1 = value;
  },
  setDailyStatsParam2: function setDailyStatsParam2(state, value) {
    state.dailyStatsParam2 = value;
  },
  setTableCellParts: function setTableCellParts(state, parts) {
    state.tableCellParts = parts;
  },
  setWorkers: function setWorkers(state, workers) {
    state.workers = workers;
  },
  setWorkersForFullDayEditor: function setWorkersForFullDayEditor(state, workers) {
    state.workersForFullDayEditor = workers;
  },
  // setEmployments (state, employments) {
  //   state.employments = employments
  // },
  setWorkerDays: function setWorkerDays(state, workerDays) {
    // console.warn('Worker days', workerDays)
    state.workerDays = workerDays;
  },
  setRollbackCellData: function setRollbackCellData(state, _ref4) {
    var index = _ref4.index,
        value = _ref4.value;
    rollbackWorkerDays.set(index, deepClone(value));
  },
  doRollbackCellData: function doRollbackCellData(state, _ref5) {
    var prevCellId = _ref5.prevCellId,
        changed = _ref5.changed;
    changed.forEach(function (changedItem, i) {
      if (changedItem === true) {
        var rollbackData = rollbackWorkerDays.get(i);

        if (rollbackData) {
          Vue.set(state.workerDays[i], prevCellId, deepClone(rollbackData));
        }
      }
    });
    rollbackWorkerDays.purge();
  },
  changeDay: function changeDay(vuexState, _ref6) {
    var cellId = _ref6.cellId,
        changedDay = _ref6.changedDay;

    if (!vuexState.workerDays[0]) {
      if (!changedDay) {
        return;
      }

      Vue.set(vuexState.workerDays, 0, _defineProperty({}, cellId, changedDay));
      return;
    }

    if (!changedDay) {
      delete vuexState.workerDays[0][cellId];
      return;
    }

    Vue.set(vuexState.workerDays[0], cellId, changedDay);
  },
  setWorkTypes: function setWorkTypes(state, workTypes) {
    state.workTypes = workTypes;
  },
  setLoadingDay: function setLoadingDay(state, _ref7) {
    var refId = _ref7.refId;
    state.loadingDay = refId;
  },
  setWorkerStats: function setWorkerStats(state, stats) {
    state.workerStats = stats;
  },
  setOtherDailyStats: function setOtherDailyStats(state, stats) {
    state.otherDailyStats = stats;
  },
  setDayFilters: function setDayFilters(state, _ref8) {
    var filters = _ref8.filters,
        date = _ref8.date;

    // !!!
    if (date !== lastDayFilterDate) {
      if (lastDayFilterDate) Vue.set(state.dayFilters, lastDayFilterDate, []);
      lastDayFilterDate = date;
    } /// /!!!


    Vue.set(state.dayFilters, date, filters);
    var ids = state.workers.map(function (worker) {
      return worker['employee_id'];
    });
    ids.forEach(function (emplId) {
      var _state$workerDays$, _state$workerDays$$da, _state$workerDays$2, _state$workerDays$2$d;

      var dayId = date + '_' + emplId;
      var workerIndex = state.workers.findIndex(function (worker) {
        return worker['employee_id'] === emplId;
      });
      var type = ((_state$workerDays$ = state.workerDays[0]) === null || _state$workerDays$ === void 0 ? void 0 : (_state$workerDays$$da = _state$workerDays$[dayId]) === null || _state$workerDays$$da === void 0 ? void 0 : _state$workerDays$$da['type']) || ((_state$workerDays$2 = state.workerDays[1]) === null || _state$workerDays$2 === void 0 ? void 0 : (_state$workerDays$2$d = _state$workerDays$2[dayId]) === null || _state$workerDays$2$d === void 0 ? void 0 : _state$workerDays$2$d['type']);
      var workerVisibilityState = filters.length ? filters.includes(type) : true;
      state.workers[workerIndex]['visible_after_filter'] = workerVisibilityState;
    });
  },
  setWorkerSortType: function setWorkerSortType(state, _ref9) {
    var sortType = _ref9.sortType;
    state.sortType = sortType;
    var statsIndex = 0; // state.tableCellParts.length === 2 ? 1 : 0

    var sortHandlers = {
      position: function position() {
        state.workers.sort(firstBy('position_name'));
      },
      'fullname-0-1': function fullname01() {
        state.workers.sort(firstBy('fullname'));
      },
      workingDaysAmount: function workingDaysAmount() {
        state.workers = sortStatsData({
          workers: state.workers,
          stats: state.workerStats[statsIndex],
          sortField: 'day_type_W',
          sortDirection: -1
        });
      },
      holidaysAmount: function holidaysAmount() {
        state.workers = sortStatsData({
          workers: state.workers,
          stats: state.workerStats[statsIndex],
          sortField: 'day_type_H',
          sortDirection: -1
        });
      }
    };
    var sortHandler = sortHandlers[sortType];

    if (sortHandler) {
      sortHandler();
    }
  },
  increaseTableCellKey: function increaseTableCellKey(state) {
    state.tableCellKey += 1;
  },
  setTabels: function setTabels(state, tabels) {
    state.tabels = tabels;
  },
  setCache: function setCache(state, _ref10) {
    var name = _ref10.name,
        key = _ref10.key,
        value = _ref10.value;
    state.cachedData[name][key] = value;
  },
  clearCache: function clearCache(state, _ref11) {
    var name = _ref11.name;
    state.cachedData[name] = {};
  },
  setTasks: function setTasks(state, tasks) {
    state.tasks = tasks;
  },
  setDefaultStats: function setDefaultStats(state, defaultStats) {
    state.dailyStatsParam1 = defaultStats.day_top;
    state.dailyStatsParam2 = defaultStats.day_bottom;
    state.employeeStats = {
      top: defaultStats.employee_top,
      bottom: defaultStats.employee_bottom
    };
    state.timesheetStats = {
      top: defaultStats.timesheet_employee_top,
      bottom: defaultStats.timesheet_employee_bottom
    };
  },
  setBottomCorners: function setBottomCorners(state, cornersData) {
    state.bottomCorners = cornersData;
  },
  setDayInEditing: function setDayInEditing(state, dayInEditing) {
    state.dayInEditing = dayInEditing;
  },
  addShift: function addShift(state, _ref12) {
    var _ref12$partIndex = _ref12.partIndex,
        partIndex = _ref12$partIndex === void 0 ? 0 : _ref12$partIndex,
        shift = _ref12.shift;
    var hasIntegrationPersonnelShift = Object.values(state.dayInEditing || {}).some(function (day) {
      var _day$shifts;

      return day === null || day === void 0 ? void 0 : (_day$shifts = day.shifts) === null || _day$shifts === void 0 ? void 0 : _day$shifts.some(function (currentShift) {
        return currentShift.code;
      });
    });

    if (hasIntegrationPersonnelShift && state.workDayTypes.includes(shift.type)) {
      shift.is_vacancy = true;
    }

    addToShifts(state, shift.cellId, shift.newId, 'newShifts');
    state.dayInEditing[partIndex].shifts.push(shift);
  },
  removeShift: function removeShift(state, _ref13) {
    var _ref13$partIndex = _ref13.partIndex,
        partIndex = _ref13$partIndex === void 0 ? 0 : _ref13$partIndex,
        shiftIndex = _ref13.shiftIndex,
        shiftIndexes = _ref13.shiftIndexes,
        shiftId = _ref13.shiftId,
        cellId = _ref13.cellId;
    addToShifts(state, cellId, shiftId, 'removedShifts');

    if (shiftIndexes && shiftIndexes.length) {
      state.dayInEditing[partIndex].shifts = state.dayInEditing[partIndex].shifts.filter(function (_, index) {
        return !shiftIndexes.includes(index);
      });
    } else {
      var index = state.dayInEditing[partIndex].shifts.findIndex(function (el) {
        return el.id === +shiftId || el.newId === +shiftId;
      });
      state.dayInEditing[partIndex].shifts.splice(index, 1);
    }
  },
  clearDayInEditing: function clearDayInEditing(state) {
    state.dayInEditing = {};
  },
  updateDayInEditing: function updateDayInEditing(state, payload) {
    var wdId;
    var _payload$partIndex = payload.partIndex,
        partIndex = _payload$partIndex === void 0 ? 0 : _payload$partIndex,
        _payload$shiftIndex = payload.shiftIndex,
        shiftIndex = _payload$shiftIndex === void 0 ? 0 : _payload$shiftIndex,
        field = payload.field,
        value = payload.value,
        shiftId = payload.shiftId,
        newShiftId = payload.newShiftId,
        cellId = payload.cellId,
        oldDayId = payload.oldDayId,
        shifts = payload.shifts,
        changeEvent = payload.changeEvent,
        employeeMainWorkType = payload.employeeMainWorkType,
        isVacancy = payload.isVacancy;

    if (!cellId && shifts !== null && shifts !== void 0 && shifts.length) {
      var _shifts$shiftIndex, _shifts$shiftIndex2;

      cellId = (shifts === null || shifts === void 0 ? void 0 : (_shifts$shiftIndex = shifts[shiftIndex]) === null || _shifts$shiftIndex === void 0 ? void 0 : _shifts$shiftIndex.dt) + '_' + (shifts === null || shifts === void 0 ? void 0 : (_shifts$shiftIndex2 = shifts[shiftIndex]) === null || _shifts$shiftIndex2 === void 0 ? void 0 : _shifts$shiftIndex2.employee_id);
    } else if (!cellId && shifts) {
      cellId = shifts.dt + '_' + shifts.employee_id;
    }

    if (shiftId && newShiftId && !oldDayId) {
      // addToShifts(state, cellId, shiftId, 'newShifts')
      addToShifts(state, cellId, newShiftId, 'updatedShifts');
    } else if (!shiftId && newShiftId && !oldDayId) {
      addToShifts(state, cellId, newShiftId, 'newShifts');
    } else if (!oldDayId && shiftId && (shifts === null || shifts === void 0 ? void 0 : shifts.length) > 1) {
      addToShifts(state, cellId, shiftId, 'updatedShifts');
    } else if (oldDayId || shiftId) {
      if ((shifts === null || shifts === void 0 ? void 0 : shifts.length) > 1) {
        wdId = oldDayId;
      } else {
        wdId = shiftId;
      }

      if ((changeEvent === 'dayType' || changeEvent === 'isVacancy') && oldDayId) {
        addToShifts(state, cellId, wdId, 'updatedShifts');
      } else {
        if (field === 'work_type_id' || field === 'is_vacancy') {
          addToShifts(state, cellId, wdId || shiftId, 'updatedShifts');
        } else {
          addToShifts(state, cellId, shiftId, 'newShifts');
        }
      }
    }

    var shiftToEdit = shiftId ? state.dayInEditing[partIndex].shifts.find(function (el) {
      return el.id === +shiftId || el.newId === +shiftId;
    }) : state.dayInEditing[partIndex].shifts.find(function (el) {
      return el.newId === +newShiftId;
    }) || state.dayInEditing[partIndex].shifts[shiftIndex];

    if (!shiftToEdit) {
      return;
    }

    Vue.set(shiftToEdit, field, value);

    if (isVacancy && field === 'work_type_id') {
      Vue.set(shiftToEdit, 'is_vacancy', value !== employeeMainWorkType);
    }

    Vue.set(shiftToEdit, 'dttm_work_end', getCorrectShiftWorkEndTime(shiftToEdit));
  },
  setDayTypes: function setDayTypes(state, dayTypes) {
    var filteredTypes = dayTypes.filter(function (dType) {
      return dType.is_active;
    }).sort(function (a, b) {
      return b.ordering - a.ordering;
    });
    state.dayTypes = filteredTypes;
    state.dayTypeOptions = filteredTypes.map(function (dType) {
      state.dayTypesById[dType.code] = dType;
      return {
        label: dType.name,
        value: dType.code,
        plan: dType.use_in_plan,
        fact: dType.use_in_fact
      };
    });
    state.workDayTypes = filteredTypes.filter(function (dType) {
      return !dType.is_dayoff;
    }).map(function (dType) {
      return dType.code;
    });
    state.dayTypeStats = filteredTypes.reduce(function (acc, cur) {
      if (cur.show_stat_in_hours) {
        acc.push({
          label: "".concat(cur.name, " (\u0441\u0443\u043C\u043C\u0430 \u0447\u0430\u0441\u043E\u0432)"),
          value: "hours_by_type_".concat(cur.code)
        });
      }

      if (cur.show_stat_in_days) {
        acc.push({
          label: "".concat(cur.name, " (\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0434\u043D\u0435\u0439)"),
          value: "day_type_".concat(cur.code)
        });
      }

      return acc;
    }, []);
  },
  markUpdated: function markUpdated(state, tableView) {
    state.updatedData[tableView] = true;
  },
  resetMarked: function resetMarked(state) {
    workerDaysByArg.purge();
    state.updatedData = {};
  },
  setIsLoading: function setIsLoading(state, status) {
    state.isLoading = status;
  },
  setAttendanceRecords: function setAttendanceRecords(state, records) {
    for (var key in records) {
      state.attendanceRecords[key] = records[key].sort(function (a, b) {
        return dayjs(a.C) - dayjs(b.C);
      });
    }
  },
  setWorkDaysByDepartmentId: function setWorkDaysByDepartmentId(state, _ref14) {
    var departmentId = _ref14.departmentId,
        workDays = _ref14.workDays;
    state.workDays[departmentId] = workDays;
  },
  setIsFetchingWorkersForFullDayEditor: function setIsFetchingWorkersForFullDayEditor(state, value) {
    if (value) {
      state.isFetchingWorkersForFullDayEditor.push(value);
    } else {
      state.isFetchingWorkersForFullDayEditor.pop(value);
    }
  }
});

var actions = {
  updateWorkerStats: updateWorkerStats,
  applyTableView: applyTableView,
  saveCellFast: saveCellFast,
  load: load,
  updateDailyStats: updateDailyStats,
  saveCellFull: saveCellFull,
  updateVacancies: updateVacancies,
  updateEfficiency: updateEfficiency,
  duplicate: duplicate,
  deleteWorkerDays: function deleteWorkerDays(_, body) {
    return API_REQUEST('deleteWorkerDays', body);
  },
  copyApprovedWorkerDays: function copyApprovedWorkerDays(_, body) {
    return API_REQUEST('copyApprovedWorkerDays', body);
  },
  copyPasteWorkerDaysForMonth: function copyPasteWorkerDaysForMonth(_, body) {
    return API_REQUEST('copyPasteWorkerDaysForMonth', body);
  },
  exchangeWorkerDays: function exchangeWorkerDays(_, _ref15) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var cells, isApprovedDays, days, workerIds, daysArr, workerIdsArr;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cells = _ref15.cells, isApprovedDays = _ref15.isApprovedDays;
              days = {};
              workerIds = {};
              cells.forEach(function (cell) {
                var _cell$split, _cell$split2;

                var date = (_cell$split = cell.split('_')) === null || _cell$split === void 0 ? void 0 : _cell$split[0];
                var workerId = (_cell$split2 = cell.split('_')) === null || _cell$split2 === void 0 ? void 0 : _cell$split2[1];

                if (date && workerId) {
                  days[date] = null;
                  workerIds[workerId] = null;
                }
              });
              daysArr = Object.keys(days);
              workerIdsArr = Object.keys(workerIds);
              return _context.abrupt("return", API_REQUEST('exchangeWorkerDays', {
                'employee1_id': workerIdsArr[0],
                'employee2_id': workerIdsArr[1],
                'dates': daysArr,
                'is_approved': isApprovedDays
              }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  fetchWorkerDays: function fetchWorkerDays(_ref16, _ref17) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, employeeIds, departmentId, from, to, _yield$API_REQUEST, _yield$API_REQUEST2, err, result, workDays;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref16.commit;
              employeeIds = _ref17.employeeIds, departmentId = _ref17.departmentId, from = _ref17.from, to = _ref17.to;
              _context2.prev = 2;
              _context2.next = 5;
              return API_REQUEST('getWorkerDay', {
                employee_id__in: employeeIds.join(),
                dt__gte: from,
                dt__lte: to
              });

            case 5:
              _yield$API_REQUEST = _context2.sent;
              _yield$API_REQUEST2 = _slicedToArray(_yield$API_REQUEST, 2);
              err = _yield$API_REQUEST2[0];
              result = _yield$API_REQUEST2[1];

              if (!err) {
                _context2.next = 11;
                break;
              }

              throw err;

            case 11:
              workDays = result.filter(function (el) {
                return el.shop_id === +departmentId;
              });
              commit('setWorkDaysByDepartmentId', {
                departmentId: departmentId,
                workDays: workDays
              });
              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](2);
              console.error(_context2.t0);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 15]]);
    }))();
  },
  waitForFetchingEmployees: function waitForFetchingEmployees(_ref18) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var vuexState;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              vuexState = _ref18.state;
              _context3.prev = 1;
              _context3.next = 4;
              return new Promise(function (resolve, reject) {
                var timer = setInterval(function () {
                  if (!vuexState.isFetchingWorkersForFullDayEditor.length) {
                    clearInterval(timer);
                    resolve(true);
                  }
                }, POLL_INTERVAL);
                setTimeout(function () {
                  reject(new Error('Timeout'));
                }, POLL_TIMEOUT);
              });

            case 4:
              _context3.next = 9;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
              console.error(_context3.t0.message);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 6]]);
    }))();
  },

  /**
   * Fetches employees from the server
   * @param {Store} store
   * @param {object} options
   * @param {string=} options.dateFrom
   * @param {string=} options.dateTo
   * @param {(string|number)[]=} options.employeeIds
   * @param {string|number=} options.departmentId
   */
  fetchEmployees: function fetchEmployees(_ref19, _ref20) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var dispatch, commit, rootGetters, state, dateFrom, dateTo, employeeIds, departmentId, _ref20$isLeaveExisted, isLeaveExisted, _ref20$isForFullDayEd, isForFullDayEditor, _ref20$isSkipEmployme, isSkipEmployments, mutationName, params, key, existed, employees, employeesFromServer, positionsIndexed, workers, employmentsToAdd, newWorkersIds, oldWorkers;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch = _ref19.dispatch, commit = _ref19.commit, rootGetters = _ref19.rootGetters, state = _ref19.state;
              dateFrom = _ref20.dateFrom, dateTo = _ref20.dateTo, employeeIds = _ref20.employeeIds, departmentId = _ref20.departmentId, _ref20$isLeaveExisted = _ref20.isLeaveExisted, isLeaveExisted = _ref20$isLeaveExisted === void 0 ? false : _ref20$isLeaveExisted, _ref20$isForFullDayEd = _ref20.isForFullDayEditor, isForFullDayEditor = _ref20$isForFullDayEd === void 0 ? false : _ref20$isForFullDayEd, _ref20$isSkipEmployme = _ref20.isSkipEmployments, isSkipEmployments = _ref20$isSkipEmployme === void 0 ? false : _ref20$isSkipEmployme;
              mutationName = isForFullDayEditor ? 'setWorkersForFullDayEditor' : 'setWorkers';
              _context4.prev = 3;

              if (!isForFullDayEditor) {
                _context4.next = 8;
                break;
              }

              _context4.next = 7;
              return dispatch('waitForFetchingEmployees');

            case 7:
              commit('setIsFetchingWorkersForFullDayEditor', true);

            case 8:
              params = formFetchEmployeeParams({
                dateFrom: dateFrom,
                dateTo: dateTo,
                employeeIds: employeeIds,
                departmentId: departmentId,
                isSkipEmployments: isSkipEmployments
              });
              key = JSON.stringify(params);
              existed = fetchEmployeeMemo[key];

              if (!existed) {
                _context4.next = 15;
                break;
              }

              employees = JSON.parse(JSON.stringify(existed));
              _context4.next = 20;
              break;

            case 15:
              _context4.next = 17;
              return fetchEmployeesChunked(params);

            case 17:
              employeesFromServer = _context4.sent;
              fetchEmployeeMemo[key] = employeesFromServer;
              employees = JSON.parse(JSON.stringify(employeesFromServer));

            case 20:
              positionsIndexed = rootGetters['staff/positionsIndexed'];
              workers = employees.map(function (employee) {
                return formWorker({
                  rawEmployee: employee,
                  departmentId: departmentId,
                  positionsIndexed: positionsIndexed
                }, [dateFrom, dateTo]);
              });
              employmentsToAdd = [];
              employees.forEach(function (employee) {
                if (!employee.employments || !employee.employments.length) {
                  return;
                }

                employmentsToAdd.push.apply(employmentsToAdd, _toConsumableArray(employee.employments));
              });

              if (isLeaveExisted) {
                newWorkersIds = lens(workers, 'employee_id');
                oldWorkers = state[isForFullDayEditor ? 'workersForFullDayEditor' : 'workers'].filter(function (el) {
                  return !newWorkersIds.includes(el.employee_id);
                });
                commit(mutationName, [].concat(_toConsumableArray(workers), _toConsumableArray(oldWorkers)));
              } else {
                commit(mutationName, workers);
              }

              if (!isForFullDayEditor) {
                _context4.next = 28;
                break;
              }

              commit('setIsFetchingWorkersForFullDayEditor', false);
              return _context4.abrupt("return");

            case 28:
              dispatch('staff/addEmployments', employmentsToAdd, {
                root: true
              });
              _context4.next = 35;
              break;

            case 31:
              _context4.prev = 31;
              _context4.t0 = _context4["catch"](3);
              console.error(_context4.t0);
              commit('setIsFetchingWorkersForFullDayEditor', false);

            case 35:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 31]]);
    }))();
  },
  getDataForAllTables: function getDataForAllTables(_ref21, _ref22) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var dispatch, commit, rootGetters, from, to, depId, resetFilterWorkers, _yield$Promise$all, _yield$Promise$all2, workTypes;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              dispatch = _ref21.dispatch, commit = _ref21.commit, rootGetters = _ref21.rootGetters;
              from = _ref22.from, to = _ref22.to, depId = _ref22.depId, resetFilterWorkers = _ref22.resetFilterWorkers;
              _context5.next = 4;
              return Promise.all([dispatch('cachedData/getWorkTypes', {}, {
                root: true
              }), // dispatch('staff/fetchPositions', {}, { root: true }),
              dispatch('staff/fetchWorkTypes', {}, {
                root: true
              })]);

            case 4:
              _yield$Promise$all = _context5.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
              workTypes = _yield$Promise$all2[0];
              _context5.next = 9;
              return dispatch('fetchEmployees', {
                dateFrom: from,
                dateTo: to,
                departmentId: depId
              });

            case 9:
              commit('setWorkTypes', workTypes);
              commit('application/setPrimaryPageLoaded', {
                value: true
              }, {
                root: true
              });
              commit('setWorkerSortType', {
                sortType: state.sortType
              });

              if (resetFilterWorkers) {
                dispatch('queryMirrored/setParams', {
                  elements: [{
                    name: 'timetable>staff>workersFilter',
                    value: 'all'
                  }, {
                    name: 'timetable>staff>workTypesFilter',
                    value: 'all'
                  }, {
                    name: 'timetable>staff>workerTypesFilter',
                    value: 'all'
                  }]
                }, {
                  root: true
                });
              }

              commit('increaseTableCellKey');
              commit('markUpdated', 'allTable');

            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  getTabelData: function getTabelData(_ref23, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var commit, _yield$Promise$all3, _yield$Promise$all4, timesheetsRes, timesheetStats, tabels, timesheets, workerId, stats;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref23.commit;
              _context6.next = 3;
              return Promise.all([API_REQUEST('getTimesheet', params), API_REQUEST('getTimesheetStats', params)]);

            case 3:
              _yield$Promise$all3 = _context6.sent;
              _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
              timesheetsRes = _yield$Promise$all4[0];
              timesheetStats = _yield$Promise$all4[1];
              tabels = {};
              timesheets = timesheetsRes[1] || [];
              timesheets.forEach(function (val) {
                var key = "".concat(val['dt'], "_").concat(val['employee_id']);
                var startWork = val['fact_timesheet_dttm_work_start'] && dayjs(val['fact_timesheet_dttm_work_start']).format('HH:mm');
                var endWork = val['fact_timesheet_dttm_work_end'] && dayjs(val['fact_timesheet_dttm_work_end']).format('HH:mm');
                var tabel = {
                  factType: val['fact_timesheet_type'],
                  factTotal: val['fact_timesheet_total_hours'],
                  factDay: val['fact_timesheet_day_hours'],
                  factNight: val['fact_timesheet_night_hours'],
                  mainType: val['main_timesheet_type'],
                  mainTotal: val['main_timesheet_total_hours'],
                  mainDay: val['main_timesheet_day_hours'],
                  mainNight: val['main_timesheet_night_hours'],
                  additionalTotal: val['additional_timesheet_hours'],
                  additionalDay: val['additional_timesheet_day_hours'],
                  additionalNight: val['additional_timesheet_night_hours'],
                  startWorkTime: startWork || '',
                  endWorkTime: endWork || ''
                };
                tabels[key] = tabel;
              });
              commit('setTabels', tabels);
              workerStatsByArg.purge('FACT_TABEL');

              for (workerId in timesheetStats[1]) {
                stats = timesheetStats[1][workerId];
                workerStatsByArg.set('FACT_TABEL', workerId, prepareStats(stats));
              }

              commit('markUpdated', 'tabel');

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  getWorkerDays: function getWorkerDays(_ref24, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var dispatch, commit, rootGetters, rootState, depId, _yield$API_REQUEST3, _yield$API_REQUEST4, wDays, wTypesById, depIds, fields, idx, _i, _fields, field;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch = _ref24.dispatch, commit = _ref24.commit, rootGetters = _ref24.rootGetters, rootState = _ref24.rootState;
              depId = rootGetters['queryMirrored/getOneDep'];
              _context7.next = 4;
              return API_REQUEST('getWorkerDay', params);

            case 4:
              _yield$API_REQUEST3 = _context7.sent;
              _yield$API_REQUEST4 = _slicedToArray(_yield$API_REQUEST3, 2);
              wDays = _yield$API_REQUEST4[1];
              wTypesById = rootState.cachedData.workTypes || {};

              if (params.isForce) {
                workerDaysByArg.purge();
              }

              depIds = [];
              wDays.forEach(function (wDay) {
                var isFact = wDay['is_fact'];
                var isApproved = wDay['is_approved'];
                var itemArg;

                if (isFact === false) {
                  // PLAN
                  itemArg = isApproved ? 'PLAN_APPR' : 'PLAN_UNAPPR';
                } else {
                  itemArg = isApproved ? 'FACT_APPR' : 'FACT_UNAPPR';
                }

                var shop_id = wDay.shop_id,
                    type = wDay.type;
                wDay.isAnotherDep = type === 'W' && shop_id !== Number(depId);

                if (shop_id && !wTypesById[shop_id] && !depIds.includes(shop_id)) {
                  depIds.push(shop_id);
                }

                if (!itemArg) {
                  return;
                }

                if (wDay['worker_day_details'] && Array.isArray(wDay['worker_day_details']) && wDay['worker_day_details'][0]) {
                  wDay['work_type_id'] = wDay['worker_day_details'][0]['work_type_id'];
                }

                var dayKey = wDay['dt'] + '_' + wDay['employee_id'];
                workerDaysByArg.add(itemArg, dayKey, wDay); // ! Недопустимая мутация стэйта!!!
              });

              if (depIds.length) {
                dispatch('cachedData/getWorkTypes', {
                  updateStrictly: true,
                  byDepId: depIds
                }, {
                  root: true
                });
              }

              fields = ['factData', 'planData'];

              if (params.hasOwnProperty('is_fact')) {
                idx = Number(params['is_fact']);
                fields.splice(idx, 1);
              }

              for (_i = 0, _fields = fields; _i < _fields.length; _i++) {
                field = _fields[_i];
                commit('markUpdated', field);
              }

            case 15:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  getAttendanceRecords: function getAttendanceRecords(_ref25, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var rootGetters, commit, _yield$API_REQUEST5, _yield$API_REQUEST6, response, allDepartmentsById, recordsById, records, key, keyName;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              rootGetters = _ref25.rootGetters, commit = _ref25.commit;
              _context8.next = 3;
              return API_REQUEST('getAttendanceRecords', params);

            case 3:
              _yield$API_REQUEST5 = _context8.sent;
              _yield$API_REQUEST6 = _slicedToArray(_yield$API_REQUEST5, 2);
              response = _yield$API_REQUEST6[1];
              allDepartmentsById = rootGetters['cachedData/allDepartmentsById'];
              recordsById = {};
              response.forEach(function (el) {
                if (el.verified && el.employee_id) {
                  var keyName = "".concat(el['dt'], "_").concat(el['employee_id'], "_").concat(el.shop_id);

                  if (!recordsById[keyName]) {
                    recordsById[keyName] = {
                      id: el.id
                    };
                  }

                  if (!recordsById[keyName].depName) {
                    var _allDepartmentsById$e;

                    recordsById[keyName].depName = (_allDepartmentsById$e = allDepartmentsById[el.shop_id]) === null || _allDepartmentsById$e === void 0 ? void 0 : _allDepartmentsById$e.name;
                  }

                  recordsById[keyName].isFraud = el.is_fraud;

                  if (recordsById[keyName][el.type]) {
                    if (el.type === 'C' && dayjs(el.dttm) < dayjs(recordsById[keyName][el.type])) {
                      recordsById[keyName][el.type] = el.dttm;
                    }

                    if (el.type === 'L' && dayjs(el.dttm) > dayjs(recordsById[keyName][el.type])) {
                      recordsById[keyName][el.type] = el.dttm;
                    }
                  } else {
                    recordsById[keyName][el.type] = el.dttm;
                  }
                }
              });
              records = {};

              for (key in recordsById) {
                keyName = key.split('_').splice(0, 2).join('_');

                if (!records[keyName]) {
                  records[keyName] = [recordsById[key]];
                } else {
                  records[keyName].push(recordsById[key]);
                }
              }

              commit('setAttendanceRecords', records);
              commit('markUpdated', 'attendanceRecords');

            case 13:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },
  getTasks: function getTasks(_ref26, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var commit, _yield$Promise$all5, _yield$Promise$all6, tasksRes, tasks;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref26.commit;
              _context9.next = 3;
              return Promise.all([API_REQUEST('getTasks', params)]);

            case 3:
              _yield$Promise$all5 = _context9.sent;
              _yield$Promise$all6 = _slicedToArray(_yield$Promise$all5, 1);
              tasksRes = _yield$Promise$all6[0];

              if (tasksRes[1]) {
                tasks = {};
                tasksRes[1].sort(function (a, b) {
                  return new Date(a.dttm_start_time) - new Date(b.dttm_start_time);
                }).forEach(function (task) {
                  var name = "".concat(task.dt, "_").concat(task.employee_id);
                  var newTask = {
                    startTime: task.dttm_start_time,
                    endTime: task.dttm_end_time,
                    shopId: task.operation_type.shop_id,
                    name: task.operation_type.operation_type_name.name,
                    id: task.id
                  };

                  if (tasks[name]) {
                    tasks[name].push(newTask);
                  } else {
                    tasks[name] = [newTask];
                  }
                });
                commit('setTasks', tasks);
              }

              commit('markUpdated', 'tasks');

            case 8:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  },
  getDayTypes: function getDayTypes(_ref27) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var commit, _yield$API_REQUEST7, _yield$API_REQUEST8, dayTypesRes;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit = _ref27.commit;
              _context10.next = 3;
              return API_REQUEST('getDayTypes');

            case 3:
              _yield$API_REQUEST7 = _context10.sent;
              _yield$API_REQUEST8 = _slicedToArray(_yield$API_REQUEST7, 2);
              dayTypesRes = _yield$API_REQUEST8[1];
              commit('setDayTypes', dayTypesRes); // console.warn('!!Внимание!! dayTypes заменены на моковые!!!')
              // commit('setDayTypes', dayTypesMocked)

            case 7:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  },
  prepareDayForEditing: function prepareDayForEditing(_ref28, _ref29) {
    var _workerEmployments$fi, _wTypes$sort$;

    var state = _ref28.state,
        commit = _ref28.commit,
        getters = _ref28.getters,
        rootGetters = _ref28.rootGetters,
        rootState = _ref28.rootState;
    var wDay = _ref29.wDay,
        cellId = _ref29.cellId;
    var depId = rootGetters['queryMirrored/getOneDep'];
    var dayInEditing = deepClone(wDay);

    var _dayInEditing = _slicedToArray(dayInEditing, 2),
        mainData = _dayInEditing[0],
        cornerData = _dayInEditing[1];

    var emplId = Number(cellId.split('_')[1]);
    var worker = state.workers.find(function (w) {
      return w.employee_id === emplId;
    });
    var workerEmployments = rootGetters['staff/employmentsByUserId'][worker.user_id];
    var actualEmploymentFromAllEmployments = workerEmployments === null || workerEmployments === void 0 ? void 0 : (_workerEmployments$fi = workerEmployments.filter(function (employment) {
      var date = new Date(cellId.split('_')[0]);
      return employment.shop_id === Number(depId) && date >= new Date(employment.dt_hired) && (!employment.dt_fired || date <= new Date(employment.dt_fired));
    })) === null || _workerEmployments$fi === void 0 ? void 0 : _workerEmployments$fi[0];
    var actualEmploymentForChosenDate = null;
    var wTypes = deepClone(worker === null || worker === void 0 ? void 0 : worker.work_types) || [];
    var wTypeId = (_wTypes$sort$ = wTypes.sort(function (a, b) {
      return b.priority - a.priority;
    })[0]) === null || _wTypes$sort$ === void 0 ? void 0 : _wTypes$sort$.work_type_id;
    var workType = state.workTypes.find(function (wType) {
      return wType.id === wTypeId;
    });

    if (actualEmploymentFromAllEmployments) {
      var _state$workTypes$find;

      var workTypes = _toConsumableArray(actualEmploymentFromAllEmployments.work_types);

      actualEmploymentForChosenDate = (_state$workTypes$find = state.workTypes.find(function (wType) {
        var _workTypes$sort$;

        return wType.id === ((_workTypes$sort$ = workTypes.sort(function (a, b) {
          return b.priority - a.priority;
        })[0]) === null || _workTypes$sort$ === void 0 ? void 0 : _workTypes$sort$.work_type_id);
      })) === null || _state$workTypes$find === void 0 ? void 0 : _state$workTypes$find.id;
    }

    if (!workType) {
      workType = state.workTypes[0] || {};
    }

    if (!mainData.hasOwnProperty('id')) {
      var type = getters.getDayTypes[0].code;

      if (rootState.user.data.network.allow_to_manually_set_is_vacancy) {
        var _cellId$split;

        var id = rootGetters['staff/employmentMainWorkType']((_cellId$split = cellId.split('_')) === null || _cellId$split === void 0 ? void 0 : _cellId$split[1]);
        dayInEditing[0] = {
          shifts: [{
            type: type,
            work_type_id: actualEmploymentForChosenDate || workType.id,
            shop_id: depId,
            is_vacancy: actualEmploymentForChosenDate && actualEmploymentForChosenDate !== workType.id ? false : id !== workType.id
          }]
        };
      } else {
        dayInEditing[0] = {
          shifts: [{
            type: type,
            work_type_id: actualEmploymentForChosenDate || workType.id,
            shop_id: depId
          }]
        };
      }
    } else {
      dayInEditing[0].shifts.forEach(function (day) {
        if (!day.shop_id) {
          day.shop_id = depId;
        }
      });
    }

    dayInEditing[0].defaultWorkType = actualEmploymentForChosenDate || workType.id;
    commit('setDayInEditing', dayInEditing);
  },
  getTimesheetItemsByEmployee: function getTimesheetItemsByEmployee(_ref30, _ref31) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var commit, employeeId, employeeIds, startDate, endDate, _ref31$refetchInterva, refetchInterval, cacheKey, employeesIdsFiltered, payload, _yield$API_REQUEST9, _yield$API_REQUEST10, err, items;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit = _ref30.commit;
              employeeId = _ref31.employeeId, employeeIds = _ref31.employeeIds, startDate = _ref31.startDate, endDate = _ref31.endDate, _ref31$refetchInterva = _ref31.refetchInterval, refetchInterval = _ref31$refetchInterva === void 0 ? TIMESHEET_ITEM_REFETCH_INTERVAL : _ref31$refetchInterva;
              _context11.prev = 2;

              if (!(!employeeId && !employeeIds)) {
                _context11.next = 5;
                break;
              }

              return _context11.abrupt("return");

            case 5:
              cacheKey = employeeId + startDate + endDate;

              if (!timesheetItemsFetchCache.get(cacheKey)) {
                _context11.next = 8;
                break;
              }

              return _context11.abrupt("return");

            case 8:
              if (employeeIds && employeeIds.length) {
                employeesIdsFiltered = employeeIds.filter(function (el) {
                  return !timesheetItemsFetchCache.get(el + startDate + endDate);
                });
              }

              if (!(employeesIdsFiltered && !employeesIdsFiltered.length)) {
                _context11.next = 13;
                break;
              }

              return _context11.abrupt("return");

            case 13:
              if (employeesIdsFiltered) {
                employeesIdsFiltered.forEach(function (id) {
                  timesheetItemsFetchCache.set(id + startDate + endDate, true);
                });
                setTimeout(function () {
                  employeesIdsFiltered.forEach(function (id) {
                    timesheetItemsFetchCache.delete(id + startDate + endDate);
                  });
                }, refetchInterval);
              }

            case 14:
              timesheetItemsFetchCache.set(cacheKey, true);
              setTimeout(function () {
                timesheetItemsFetchCache.delete(cacheKey);
              }, refetchInterval);
              payload = {
                dt__gte: startDate,
                dt__lte: endDate
              };

              if (employeeId === undefined) {
                payload.employee_id__in = employeesIdsFiltered.join();
              } else {
                payload.employee_id = employeeId;
              }

              _context11.next = 20;
              return API_REQUEST('getTimesheetItems', payload, true);

            case 20:
              _yield$API_REQUEST9 = _context11.sent;
              _yield$API_REQUEST10 = _slicedToArray(_yield$API_REQUEST9, 2);
              err = _yield$API_REQUEST10[0];
              items = _yield$API_REQUEST10[1];

              if (!err) {
                _context11.next = 26;
                break;
              }

              throw err;

            case 26:
              commit('addTimesheetItems', {
                items: items,
                uniqueKey: 'id'
              });
              _context11.next = 32;
              break;

            case 29:
              _context11.prev = 29;
              _context11.t0 = _context11["catch"](2);
              console.error('Unable to load timesheet items:', _context11.t0.message);

            case 32:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[2, 29]]);
    }))();
  },
  fetchWorkTypeNames: function fetchWorkTypeNames(_ref32) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      var commit, rootState, params, _yield$API_REQUEST11, _yield$API_REQUEST12, err, items;

      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              commit = _ref32.commit, rootState = _ref32.rootState;
              _context12.prev = 1;
              params = {};

              if (rootState.user.data.network.clients.length) {
                params.include_clients = true;
              }

              if (rootState.user.data.network.outsourcings.length) {
                params.include_outsources = true;
              }

              _context12.next = 7;
              return API_REQUEST('getWorkTypeName', params);

            case 7:
              _yield$API_REQUEST11 = _context12.sent;
              _yield$API_REQUEST12 = _slicedToArray(_yield$API_REQUEST11, 2);
              err = _yield$API_REQUEST12[0];
              items = _yield$API_REQUEST12[1];

              if (!err) {
                _context12.next = 13;
                break;
              }

              throw err;

            case 13:
              commit('setWorkTypeNames', {
                items: items,
                uniqueKey: 'id'
              });
              _context12.next = 19;
              break;

            case 16:
              _context12.prev = 16;
              _context12.t0 = _context12["catch"](1);
              console.error('Unable to fetch work type names:', _context12.t0.message);

            case 19:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[1, 16]]);
    }))();
  },
  fetchPositions: function fetchPositions(_ref33) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      var commit, _yield$API_REQUEST13, _yield$API_REQUEST14, err, items;

      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              commit = _ref33.commit;
              _context13.prev = 1;
              _context13.next = 4;
              return API_REQUEST('getAllWorkerPositions', {
                include_clients: true
              });

            case 4:
              _yield$API_REQUEST13 = _context13.sent;
              _yield$API_REQUEST14 = _slicedToArray(_yield$API_REQUEST13, 2);
              err = _yield$API_REQUEST14[0];
              items = _yield$API_REQUEST14[1];

              if (!err) {
                _context13.next = 10;
                break;
              }

              throw err;

            case 10:
              commit('setPositions', {
                items: items,
                uniqueKey: 'id'
              });
              _context13.next = 16;
              break;

            case 13:
              _context13.prev = 13;
              _context13.t0 = _context13["catch"](1);
              console.error('Unable to fetch positions:', _context13.t0.message);

            case 16:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[1, 13]]);
    }))();
  },
  softFactFetch: function softFactFetch(_ref34) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      var dispatch, getters, employeeIds, employeeChunks, dates, startDate, endDate, _iterator, _step, chunk;

      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              dispatch = _ref34.dispatch, getters = _ref34.getters;
              employeeIds = lens(getters.workers.filter(function (el) {
                return !!el.has_shop_employment;
              }), 'employee_id');
              employeeChunks = splitArray(employeeIds, WORKER_CHUNK_SIZE);
              dates = getters.visibleDates;
              startDate = dates[0];
              endDate = dates[dates.length - 1];
              _iterator = _createForOfIteratorHelper(employeeChunks);
              _context14.prev = 7;

              _iterator.s();

            case 9:
              if ((_step = _iterator.n()).done) {
                _context14.next = 15;
                break;
              }

              chunk = _step.value;
              _context14.next = 13;
              return dispatch('getTimesheetItemsByEmployee', {
                employeeIds: chunk,
                startDate: startDate,
                endDate: endDate
              });

            case 13:
              _context14.next = 9;
              break;

            case 15:
              _context14.next = 20;
              break;

            case 17:
              _context14.prev = 17;
              _context14.t0 = _context14["catch"](7);

              _iterator.e(_context14.t0);

            case 20:
              _context14.prev = 20;

              _iterator.f();

              return _context14.finish(20);

            case 23:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[7, 17, 20, 23]]);
    }))();
  },

  /**
   * @unused
   */
  fetchWorkers: function fetchWorkers(_ref35, _ref36) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      var dispatch, commit, from, to, depId, resetFilterWorkers, _yield$Promise$all7, _yield$Promise$all8, workTypes, emplResult, workerPositions, workers;

      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              dispatch = _ref35.dispatch, commit = _ref35.commit;
              from = _ref36.from, to = _ref36.to, depId = _ref36.depId, resetFilterWorkers = _ref36.resetFilterWorkers;
              _context15.next = 4;
              return Promise.all([dispatch('cachedData/getWorkTypes', {}, {
                root: true
              }), API_REQUEST('getEmployments', {
                'dt_from': from,
                'dt_to': to,
                'shop_id': depId,
                include_employee: true
              }), dispatch('cachedData/getAllWorkerPositions', {}, {
                root: true
              })]);

            case 4:
              _yield$Promise$all7 = _context15.sent;
              _yield$Promise$all8 = _slicedToArray(_yield$Promise$all7, 3);
              workTypes = _yield$Promise$all8[0];
              emplResult = _yield$Promise$all8[1];
              workerPositions = _yield$Promise$all8[2];
              commit('setWorkTypes', workTypes);
              workers = emplResult[1].map(function (empl) {
                var userData = _objectSpread({}, empl.employee.user);

                userData.fullname = "".concat(userData['last_name'], " ").concat(userData['first_name'], " ").concat(userData['middle_name'] || '');

                if (empl['position_id']) {
                  var _workerPositions$find;

                  userData['position_name'] = (_workerPositions$find = workerPositions.find(function (item) {
                    return item.id === empl['position_id'];
                  })) === null || _workerPositions$find === void 0 ? void 0 : _workerPositions$find.name;
                }

                userData['visible_after_filter'] = true;
                delete empl.employee;
                delete userData.id;

                if (!userData.tabel_code) {
                  delete userData.tabel_code;
                }

                return Object.assign({}, empl, userData);
              }).reduce(function (acc, cur, index, employments) {
                // only unique workers
                if (!acc.some(function (item) {
                  return item.employee_id === cur.employee_id;
                })) {
                  var sameEmplIds = employments.filter(function (empl) {
                    return empl.employee_id === cur.employee_id;
                  }).sort(function (a, b) {
                    return b.norm_work_hours - a.norm_work_hours;
                  });
                  acc.push(sameEmplIds[0]);
                }

                return acc;
              }, []);
              commit('setWorkers', workers);
              commit('application/setPrimaryPageLoaded', {
                value: true
              }, {
                root: true
              });
              commit('setWorkerSortType', {
                sortType: state.sortType
              });

              if (resetFilterWorkers) {
                dispatch('queryMirrored/setParams', {
                  elements: [{
                    name: 'timetable>staff>workersFilter',
                    value: 'all'
                  }, {
                    name: 'timetable>staff>workTypesFilter',
                    value: 'all'
                  }, {
                    name: 'timetable>staff>workerTypesFilter',
                    value: 'all'
                  }]
                }, {
                  root: true
                });
              }

              commit('increaseTableCellKey');
              commit('markUpdated', 'allTable');

            case 17:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }))();
  }
};

var getters = _objectSpread(_objectSpread({}, getUniversalGetters(state())), {}, {
  vacancies: vacancies,
  getDailyStats: getDailyStats,
  getDailyStatsSummary: getDailyStatsSummary,
  isPercent: isPercent,
  workers: function workers(state, getters, rootState, rootGetters) {
    var afterFilter = [];
    var workersFilter = rootGetters['queryMirrored/getTimetableStaffFilter']('workersFilter');
    var workTypesFilter = rootGetters['queryMirrored/getTimetableStaffFilter']('workTypesFilter');
    var workerTypesFilter = rootGetters['queryMirrored/getTimetableStaffFilter']('workerTypesFilter');
    var workersAfterWorkTypeFilter = workTypesFilter === 'all' ? state.workers : state.workers.filter(function (worker) {
      var workerWorkTypeIds = worker['work_types'].map(function (workType) {
        return workType['work_type_id'];
      });
      return !!workerWorkTypeIds.filter(function (workTypeId) {
        return workTypesFilter.includes(workTypeId);
      }).length;
    });
    afterFilter = workersFilter === 'all' ? workersAfterWorkTypeFilter : workersAfterWorkTypeFilter.filter(function (worker) {
      return workersFilter.includes(worker.employee_id);
    });
    afterFilter = workerTypesFilter === 'all' ? afterFilter : afterFilter.filter(function (worker) {
      var filterCond = false;

      if (workerTypesFilter.includes(EMPLOYEE_EMPLOYMENT_STATUSES)) {
        filterCond = filterCond || worker.has_shop_employment;
      }

      if (workerTypesFilter.includes(INTERNAL_EMPLOYMENT_STATUSES)) {
        filterCond = filterCond || !worker.has_shop_employment && !worker.from_another_network;
      }

      if (workerTypesFilter.includes(OUTSOURCE_EMPLOYMENT_STATUSES)) {
        filterCond = filterCond || worker.from_another_network;
      }

      return filterCond;
    });
    return afterFilter;
  },
  workerEmplIds: function workerEmplIds(state) {
    return state.workers.map(function (worker) {
      return worker['employee_id'];
    });
  },
  visibleDates: function visibleDates(state, getters, rootState, rootGetters) {
    var from = rootState.queryMirrored.from;
    var tableDisplay = rootState.queryMirrored.tableDisplay;
    var limit;

    switch (tableDisplay) {
      case 'day':
        limit = 1;
        break;

      case 'week':
        limit = 7;
        break;

      case 'month':
        limit = dayjs(from).add(1, 'month').diff(from, 'day');
        break;
    }

    var dates = [];

    for (var i = 0; i < limit; i++) {
      dates.push(dayjs(from).add(i, 'day').format('YYYY-MM-DD'));
    }

    return dates;
  },
  getBottomCorners: function getBottomCorners(state) {
    return state.bottomCorners;
  },
  getAttendanceRecords: function getAttendanceRecords(state) {
    return state.attendanceRecords;
  },
  getDayInEditing: function getDayInEditing(state) {
    return state.dayInEditing;
  },
  getDayTypes: function getDayTypes(state) {
    return state.dayTypes;
  },
  getDayTypesById: function getDayTypesById(state) {
    return state.dayTypesById;
  },
  getDayTypeStats: function getDayTypeStats(state) {
    return state.dayTypeStats;
  },
  getDayTypeOptions: function getDayTypeOptions(state) {
    return state.dayTypeOptions;
  },
  getWorkDayTypes: function getWorkDayTypes(state) {
    return state.workDayTypes;
  },
  workDayTypesShowHours: function workDayTypesShowHours(state) {
    return state.dayTypes.filter(function (el) {
      return el.is_dayoff && el.is_work_hours && ALLOWED_WORKER_HOUR_METHODS.includes(el.get_work_hours_method);
    }).map(function (el) {
      return el.code;
    });
  },
  workDayTypesEmptyHours: function workDayTypesEmptyHours(state) {
    return state.dayTypes.filter(function (el) {
      return el.is_dayoff && el.is_work_hours && ALLOWED_WORKER_HOUR_EMPTY_METHODS.includes(el.get_work_hours_method);
    }).map(function (el) {
      return el.code;
    });
  },
  isWorkerStatsReady: function isWorkerStatsReady(state) {
    return !!Object.keys(state.workerStats).length;
  },
  vacanciesById: function vacanciesById(state) {
    return state.vacancies ? getIndexedCollection(state.vacancies) : {};
  },
  workTypeNamesIndexed: function workTypeNamesIndexed(state) {
    return getIndexedCollection(state.workTypeNames);
  },
  positionsIndexed: function positionsIndexed(state) {
    return getIndexedCollection(state.positions);
  },
  specialDayTypeCodes: function specialDayTypeCodes(state) {
    var specialDayTypes = state.dayTypes.filter(function (el) {
      return !!el.has_details;
    });
    return specialDayTypes.length ? lens(specialDayTypes, 'code') : [DEFAULT_WORK_DAY_TYPE_CODE];
  }
});

export default {
  namespaced: true,
  mutations: mutations,
  actions: actions,
  getters: getters,
  state: state
};